import type { AsyncSequence } from "../types/AsyncSequence"
import type { GUID } from "../types/GUID"

import { MapAsync } from "../async/MapAsync"
import { StringToUInt8 } from "../bytes/StringToUInt8"
import { UInt8Hash } from "./UInt8Hash"

/**
 * Computes SHA-256 hash of a stream of strings.
 *
 * Converts each string to UTF-8 bytes and computes a deterministic hash.
 * Compatible with crypto.subtle.digest("SHA-256").
 *
 * @param stream - Async sequence of strings
 * @returns Promise resolving to GUID hash
 *
 * @example
 * ```ts
 * import { StringHash } from "@pdfking/tfunc"
 *
 * const hash = await StringHash(["hello", "world"])
 * ```
 */
export const StringHash = async (
  stream: AsyncSequence<string>
): Promise<GUID> => UInt8Hash(MapAsync(StringToUInt8, stream))
